interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
}

export const Plus = ({ width = 12, height = 12, hexColor = "#000000", }: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group 190">
            <line id="Line 9" y1="9" x2="18" y2="9" stroke={hexColor} strokeWidth="2"/>
            <line id="Line 10" x1="9" y1="18" x2="9" y2="4.37114e-08" stroke={hexColor} strokeWidth="2"/>
            </g>
        </svg>
    );
};

export default Plus;
